import React from 'react';
import { useSelector } from 'react-redux';
import { NextPage } from 'next';

import pageView, { TResponseDto as PageViewResponseDto } from '@r1-frontend/api-domru/api-content/v1/page/view';

import Layout from '~/src/features/_layout';
import About from '~/src/features/about';
import AboutV2 from '~/src/features/aboutV2';
import { REDESIGN_ABOUT } from '~/src/features/aboutV2/constants/abnVariants';
import { getPreparedContentBlocks, TPreparedContentBlocks } from '~/src/features/aboutV2/helpers';
import { getABNVariantOnSSr } from '~/src/helpers/abn-tests';
import { initialProps } from '~/src/helpers/basePageFunc';
import getRequester from '~/src/helpers/getRequester';
import { getCurrentCity, selectCompanyName } from '~/src/store/selectors/city';

interface IProps {
    isRedesignAboutAbTestActive: boolean,
    stats: TPreparedContentBlocks[],
    history: TPreparedContentBlocks[],
}

const STATS_ID = '91011';
const HISTORY_ID = '5678';

const AboutPage: NextPage<IProps> = ({ isRedesignAboutAbTestActive, stats, history }) => {
    const { cityIn } = useSelector(getCurrentCity);
    const companyName = useSelector(selectCompanyName);

    return (
        <Layout
            title={`О компании ${companyName} в ${cityIn} — история развития оператора телекоммуникационных услуг`}
            description={`О компании ${companyName} — провайдере самого быстрого интернета и цифрового телевидения в ${cityIn}. История развития и преимущества компании. Отправить заявку на подключение онлайн.`}
            withMenu={true}
            withFooter={true}
            withChat={true}
        >
            {isRedesignAboutAbTestActive ? <AboutV2 stats={stats} history={history} /> : <About />}
        </Layout>
    );
};

AboutPage.getInitialProps = async(options) => {
    await initialProps(options);
    const { store, req } = options;

    const { city: { provider: { providerId } } } = store.getState();

    const doRequest = getRequester(req);
    const isRedesignAboutAbTestActive = getABNVariantOnSSr(REDESIGN_ABOUT.testName, req) === REDESIGN_ABOUT.variants.on;

    const [stats, history] = (await Promise.all([
        doRequest.apiContent<PageViewResponseDto>(pageView(providerId, STATS_ID)),
        doRequest.apiContent<PageViewResponseDto>(pageView(providerId, HISTORY_ID)),
    ])).map(item => item.isSuccess ? getPreparedContentBlocks(item.payload.contentBlocks) : []);

    return {
        isRedesignAboutAbTestActive,
        stats,
        history: [...history].sort((a, b) => b.alias - a.alias),
    };
};

export default AboutPage;
